var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6173_10434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 11.6673C2.58714 11.6673 3.33333 10.9211 3.33333 10.0006C3.33333 9.08018 2.58714 8.33398 1.66667 8.33398C0.746192 8.33398 0 9.08018 0 10.0006C0 10.9211 0.746192 11.6673 1.66667 11.6673Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.6673C10.9206 11.6673 11.6668 10.9211 11.6668 10.0006C11.6668 9.08018 10.9206 8.33398 10.0002 8.33398C9.07969 8.33398 8.3335 9.08018 8.3335 10.0006C8.3335 10.9211 9.07969 11.6673 10.0002 11.6673Z",
    fill: "#959595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 11.6673C19.2537 11.6673 19.9999 10.9211 19.9999 10.0006C19.9999 9.08018 19.2537 8.33398 18.3332 8.33398C17.4127 8.33398 16.6665 9.08018 16.6665 10.0006C16.6665 10.9211 17.4127 11.6673 18.3332 11.6673Z",
    fill: "#959595"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6173_10434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.becbd87cd1a8ba0313ccdca33c19f206.svg";
export { ForwardRef as ReactComponent };